export const setterName = (l) =>
  l.posted_by_name || (l.posted_by ? `Setter ${l.posted_by.slice(-4)}` : "Unknown setter");

// Monday 00:00 local of the week containing `d`, shifted by `offset` weeks
export const weekStart = (offset = 0, d = new Date()) => {
  const s = new Date(d);
  s.setHours(0, 0, 0, 0);
  s.setDate(s.getDate() - ((s.getDay() + 6) % 7) + offset * 7);
  return s;
};

const inRange = (iso, start, end) => {
  if (!iso) return false;
  const t = new Date(iso);
  return t >= start && t < end;
};

const monthStart = (offset = 0, d = new Date()) => new Date(d.getFullYear(), d.getMonth() + offset, 1);

const periodRange = (mode, offset) => {
  if (mode === "month") return [monthStart(offset), monthStart(offset + 1)];
  const start = weekStart(offset);
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return [start, end];
};

export const leaderboardFor = (leads, offset, mode = "week") => {
  const [start, end] = periodRange(mode, offset);
  const rows = {};
  for (const l of leads) {
    const name = setterName(l);
    const r = (rows[name] ||= { name, posted: 0, applied: 0, approved: 0, hired: 0 });
    if (l.slack_ts && inRange(new Date(parseFloat(l.slack_ts) * 1000 || 0).toISOString(), start, end)) r.posted += 1;
    if (inRange(l.applied_at, start, end)) r.applied += 1;
    if (inRange(l.approved_at, start, end)) r.approved += 1;
    if (inRange(l.hired_at, start, end)) r.hired += 1;
  }
  const list = Object.values(rows)
    .filter((r) => r.posted || r.applied || r.approved || r.hired)
    .sort((a, b) => b.hired - a.hired || b.approved - a.approved || b.applied - a.applied || b.posted - a.posted);
  const total = list.reduce((t, r) => ({ posted: t.posted + r.posted, applied: t.applied + r.applied, approved: t.approved + r.approved, hired: t.hired + r.hired }), { posted: 0, applied: 0, approved: 0, hired: 0 });
  const last = new Date(end);
  last.setDate(last.getDate() - 1);
  return { start, end: last, list, total };
};

// winner = most Hired (ties: approved, applied, posted); none if nobody hired
export const weekWinner = (leads, offset, mode = "week") => {
  const top = leaderboardFor(leads, offset, mode).list[0];
  return top && top.hired > 0 ? top.name : null;
};
